import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.AboutPage';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Sobre123',
  },
  content: {
    id: `${ScopeName}.content`,
    defaultMessage: 'Conteúdo de exemplo <strong>Sobre</strong>',
  },
});

export default Scope;
